// Ошибки подряд в наборе дня — для реплики тренера «две ошибки подряд».
//
// Во вкладке, а не на сервере: это подсказка момента, а не метрика. Журнал
// `attempts` остаётся единственным источником правды для всего, что меряется;
// здесь только счётчик, который сбрасывается верным ответом и новым днём.

const key = (date: string) => `traektoria.missStreak.${date}`;

/** Записать вердикт свежего ответа и вернуть длину серии ошибок. */
export function recordVerdict(date: string, correct: boolean): number {
  try {
    const next = correct ? 0 : Number(window.sessionStorage.getItem(key(date)) ?? "0") + 1;
    window.sessionStorage.setItem(key(date), String(next));
    return next;
  } catch {
    // Приватное окно: без счётчика тренер просто промолчит.
    return 0;
  }
}

/** Перерыв от стольких дней — экран «Возвращение» вместо обычного «Сегодня». */
export const RETURN_AFTER_DAYS = 4;

/**
 * Сколько дней перерыва до сегодняшнего входа, или `null`, если перерыва нет.
 *
 * По дням с задачами из снимка (журнал за 21 день). Если в окне ни одного дня
 * не нашлось, перерыв — весь срок в системе, но не больше окна: точнее журнал
 * снимка не видит. Новичок первого дня — не вернувшийся, у него просто нет
 * прошлого.
 */
export function breakDays(
  days: readonly { date: string; tasks: number }[],
  today: string,
  learnerDays: number,
): number | null {
  const prev = days
    .filter((d) => d.date < today && d.tasks > 0)
    .sort((a, b) => (a.date < b.date ? 1 : -1))[0];
  // Сегодня уже были задачи, а раньше в окне ни одной — это первый день
  // (диагностика прошла только что), а не возвращение. Проба 30 октября 2026:
  // аккаунт, заведённый давно, после сегодняшней диагностики встретили словами
  // «С возвращением, перерыв 21 день».
  const activeToday = days.some((d) => d.date === today && d.tasks > 0);
  if (prev === undefined && activeToday) return null;
  const gap =
    prev !== undefined
      ? Math.round((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${prev.date}T00:00:00Z`)) / 86_400_000)
      : Math.min(learnerDays - 1, 21);
  return gap >= RETURN_AFTER_DAYS ? gap : null;
}

const dismissKey = (date: string) => `traektoria.returnSeen.${date}`;

/** Экран возвращения показан сегодня — второй раз за день он не встаёт. */
export function returnSeen(date: string): boolean {
  try {
    return window.sessionStorage.getItem(dismissKey(date)) === "1";
  } catch {
    return false;
  }
}

export function markReturnSeen(date: string): void {
  try {
    window.sessionStorage.setItem(dismissKey(date), "1");
  } catch {
    // Приватное окно: экран может встать ещё раз после перезагрузки — не беда.
  }
}
